import * as TK from 'components/auth/EmailVerificationDialog/translations/constants';
import { Translations } from 'translations/types';

export const emailVerificationDialogEnUsLocale: Translations = {
  [TK.EMAIL_VERIFICATION_DIALOG_TITLE]: 'Account Verified Successfully!',
  [TK.EMAIL_VERIFICATION_DIALOG_BUTTON_TEXT]: 'Continue',
  [TK.EMAIL_VERIFICATION_DIALOG_ICON_ALT]: 'Done icon',
};
